var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBaseBig1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.441,
    x2: 1,
    y2: 0.448,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5061ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d72ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-724 -527)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(724 527)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(733 536)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBaseBig1);
export default __webpack_public_path__ + "static/media/circle-base-big-1.fe8e34b0cb50f5f723004625ad17d839.svg";
export { ForwardRef as ReactComponent };